<template>
  <div id="timeLimitDetail">
    <img class="goBack" @click="goBack" src="../../../assets/images/activity/goBack.png" alt="">
    <div class="container">
      <div class="headerTitle" :style="{ background: getBgColor(goodDetail.storeType) }">
        <div class="shop-info">
          <div class="shop-logo">
            <img :src="goodDetail.logoUrl" alt="">
          </div>
        </div>
        <div class="shop-details">
          <div class="shop-name">
            <span class="shop-img">
              <img v-if="goodDetail.storeType == 'U'" src="@/assets/images/pt-yxdp.png" alt="">
              <img v-if="goodDetail.storeType == 'S'" src="@/assets/images/pt-zy.png" alt="">
            </span>
            <span class="name">{{ goodDetail.storeName }}</span>
          </div>
          <div class="shop-desc">
            {{ goodDetail.detail }}
          </div>
          <div class="shop-tags">
            <div class="tag-item" v-for="item of storeInfo.storeTagList" :key="item.tagId">
              <p class="title">{{ item.tagName }}</p>丨
              <p class="content">{{ item.tagDescription }}</p>
            </div>
          </div>
        </div>
        <div class="shop-actions">
          <span class="action-btn" @click="handleStorePhone(goodDetail?.storeCellphone)">
            <img src="../../../assets/images/activity/phone.png" alt="">
            联系商家</span>
          <span class="action-btn" @click="handleStoreDetail(goodDetail?.storeId)">进店逛逛<i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
      <!-- 商品主体内容 -->
      <div class="product-main">
        <div class="main_left">
          <div class="leftWrap">
            <wheelSeed :img-url-list="goodDetail.newImgs" @removeSkuImg="handleRemoveSkuImg" :skuImg='currentSkuImg' />
          </div>
          <div class="detailsBox">
            <h1>图文详情</h1>
            <div class="details">
              <div v-html="goodDetail.note" class="note-text"></div>
              <p class="price-text" v-if="goodDetail.priceDescription">价格说明:</p>
              <p v-if="goodDetail.priceDescription" v-html="goodDetail.priceDescription"></p>
            </div>
          </div>
        </div>
        <div class="main_right">
          <div class="title">
            <div v-if="activityStatus !== '已结束'" class="type">限时秒杀</div>
            <div v-else class="typeEnd">已结束</div>
            {{ goodDetail.commodityName }}
          </div>
          <div class="tags">
            <span v-for="(itemTag, indexTag) in goodDetail.tags" :key="indexTag">
              {{ itemTag.tagName }}
              <span v-show="Number(goodDetail.tags.length - 1) !== Number(indexTag)">丨</span>
            </span>
          </div>
          <div class="priceBox">
            <div style="display: flex;gap: 10px;">
              <div class="price-box">
                <span class="current-price">
                  <span style="font-size: 14px;margin-right: -4px;" v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType === 1">¥</span>
                  {{ currentPrice.discountPrice }}
                  <span v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType !== 1">提货值</span>
                </span>
                <span class="original-price">
                  <span style="font-size: 14px;margin-right: -4px;" v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType === 1">¥</span>
                  {{ currentPrice.retailPrice }}
                  <span v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType !== 1">提货值</span>
                </span>
              </div>
              <div class="stause">{{ activityStatus }}</div>
            </div>
            <div class="time">
              <span class="block">{{ hours }}</span>
              <span>:</span>
              <span class="block">{{ minutes }}</span>
              <span>:</span>
              <span class="block">{{ seconds }}</span>
              <span>{{ countdownText }}</span>
            </div>
          </div>
          <div class="inventory">
            <span>库存：{{ totalReserve }}</span>
            <span>已售：{{ totalSalesNumber }}</span>
          </div>
          <!-- <div class="Info">
            <div class="price-box">
              <span class="current-price">
                <span style="font-size: 14px;margin-right: -4px;" v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType === 1">¥</span>
                {{ currentPrice.discountPrice }}
                <span v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType !== 1">提货值</span>
              </span>
              <span class="original-price">
                <span style="font-size: 14px;margin-right: -4px;" v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType === 1">¥</span>
                {{ currentPrice.retailPrice }}
                <span v-if="goodDetail.pays && goodDetail.pays[0] && goodDetail.pays[0].payType !== 1">提货值</span>
              </span>
            </div>
            <div class="inventory">
              <span>库存：{{ totalReserve }}</span>
              <span>已售：{{ totalSalesNumber }}</span>
            </div>
          </div> -->
          <div v-if="JSON.stringify(addressObj)!='{}'" class="addressInfo">
            <div class="btwInfo">
              <div>
                送至
                <span>{{ addressObj.addressName }} </span>
              </div>
              <i class="el-icon-arrow-right" @click="addList"></i>
            </div>
          </div>
          <div class="addressInfo" v-else>
            <div class="btwInfo">
              <div>
                送至
              </div>
              <div class="addAddress" @click="goAddress">暂无地址<i class="el-icon-plus"></i></div>
            </div>
          </div>
          <div class="addressInfo">
            <div class="btwInfo">
              <div>
                运费
                <span>{{ goodDetail.distributionType === 1 ? '不包邮' : '包邮' }}</span>
              </div>
            </div>
          </div>
          <div class="addressInfo">
            <div class="btwInfo1">
              <div style="display: flex;">
                <span>服务</span>
                <div class="contentLeft">
                  {{ paramNamesTextServe }}
                </div>
                <el-dropdown trigger="click" @visible-change="handleServeDropdownChange" placement="bottom">
                  <span class="el-dropdown-link" style="margin-left: 0;cursor: pointer;">
                    <i class="el-icon-arrow-down el-icon--right dropdown-arrow" :class="{ 'is-reverse': isServeDropdownVisible }"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" popper-class="custom-parameter-dropdown">
                    <div class="serve">
                      <h1>服务说明</h1>
                      <div class="item" v-for="(param, index) in serveParams" :key="index">
                        <div class="label">
                          <div class="left">
                            <img class="img" src="../../../assets/images/activity/check.png" alt="">
                            <div class="serve_text">{{ param.serviceName }}</div>
                          </div>
                          <img class="rightImg" v-if="param.serverDetails" src="../../../assets/images/activity/right.png" alt="" @click="toDetail(param)" v-show="param.serverDetails">
                        </div>
                        <div class="value">{{ param.serviceDesc }}</div>
                      </div>
                      <div v-if="parsedProductParams.length === 0" class="no-params">
                        暂无服务信息
                      </div>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
          <div class="addressInfo">
            <div class="btwInfo">
              <div class="param-info">
                参数
                <span style="display: flex; align-item: center">
                  <div class="param-names-text">
                    {{ paramNamesText }}
                  </div>
                  <el-dropdown
                    trigger="click"
                    @visible-change="handleParamDropdownChange"
                    placement="bottom"
                  >
                    <span class="el-dropdown-link" style="margin-left: 0;cursor: pointer;">
                      <i class="el-icon-arrow-down el-icon--right dropdown-arrow" :class="{ 'is-reverse': isParamDropdownVisible }"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" popper-class="custom-parameter-dropdown">
                      <div class="parameter">
                        <h1>参数信息</h1>
                        <div class="param-list">
                          <div class="item" v-for="(param, index) in parsedProductParams" :key="index">
                            <div class="label">{{ param.paramName }}</div>
                            <div class="value">{{ param.paramValue }}</div>
                          </div>
                          <div v-if="parsedProductParams.length === 0" class="no-params">
                            暂无参数信息
                          </div>
                        </div>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </div>
            </div>
          </div>
          <div class="skus">
            <p class="title">规格</p>
            <div class="skuItem-scroll">
              <div class="skuItem">
                <div
                  class="item"
                  v-for="(sku, index) in goodDetail.activitySkus"
                  :key="sku.skuId"
                  :class="{ active: selectedSkuIndex === index }"
                  @click="selectSku(sku, index)"
                  v-show="sku.display === '1'"
                >
                  {{ sku.skuName.replace(/\|/g, " ") }}
                </div>
              </div>
            </div>
          </div>
          <div class="skusNum">
            <p class="title">
              数量
              <span v-if="limitNum > 0">（最多可购买{{ limitNum }}件）</span>
            </p>
            <div class="btnNum">
              <el-input-number v-if="limitNum > 0" v-model="num" :min="1" :max="limitNum"></el-input-number>
              <el-input-number v-else v-model="num" :min="1"></el-input-number>
              <div v-if="activityStatus === '正在疯抢'" class="btnBuy" @click="handleBuy">立即抢购</div>
              <div v-else-if="activityStatus === '即将开抢'" class="btnBuy" @click="handleImmediately">即将开抢</div>
              <div v-else class="btnBuy btnDisabled">已下架</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <addressPop ref="addressDia" :is-detail="true" @complate="complateAddress" />
    <addListDialog ref="addListDia" :choose-add-id="addressObj.addressId" @changAddId="changeAddId" />
    <Cellphone :phone="cellStore" ref="cellphoneRef" />
  </div>
</template>
<script>
/*global http protocol BaseApi Toast*/

import wheelSeed from '@/components/base/wheelSeed/wheelSeed.vue'
import addListDialog from '@/components/address/addListDialog.vue'
import addressPop from '@/components/address/addressPop.vue'
import Cellphone from '@/views/equityMall/pt/components/cellStore.vue'
import { mapMutations } from 'vuex'
export default {
  components: {
    wheelSeed,
    addListDialog,
    addressPop,
    Cellphone
  },
  data() {
    return {
      cellStore: null,
      addressObj: {},
      goodDetail: {},
      storeInfo: [], // 店铺信息
      selectedSkuIndex: 0, // 当前选中的 SKU 索引
      selectedSku: null, // 当前选中的 SKU 对象
      num: 1,
      limitNum: 1,
      currentSkuImg: '',
      isServeDropdownVisible: false, // 服务下拉菜单展开状态
      isParamDropdownVisible: false, // 参数下拉菜单展开状态
      countdownTimer: null, // 倒计时定时器
      hours: '00',
      minutes: '00',
      seconds: '00',
      countdownText: '后结束', // 倒计时文字
      activityStatus: '正在疯抢' // 活动状态文字
    }
  },
  computed: {
    // 从 Vuex 获取服务器时间偏移量
    serverTimeOffset() {
      return this.$store.state.common.serverTimeOffset || 0
    },
    // 计算总销售数量
    totalSalesNumber() {
      if (!this.goodDetail.activitySkus || this.goodDetail.activitySkus.length === 0) {
        return 0
      }
      // 即将开抢时已售为0
      if (this.activityStatus === '即将开抢') {
        return 0
      }
      // 活动开始后计算已售，加上initSalesNumber
      return this.goodDetail.activitySkus.reduce((total, sku) => {
        if (sku.display === '1') {
          const initSales = sku.initSalesNumber || 0
          const sales = sku.salesNumber || 0
          return total + initSales + sales
        } else {
          return total
        }
      }, 0)
    },
    // 计算总库存数量
    totalReserve() {
      if (!this.goodDetail.activitySkus || this.goodDetail.activitySkus.length === 0) {
        return 0
      }
      return this.goodDetail.activitySkus.reduce((total, sku) => {
        if (sku.display === '0') {
          return total
        }
        let reserve = 0
        if (!Number(sku.groupStock) || !Number(sku.initSalesNumber)) {
          sku.groupStock = sku?.groupStock | 0
          sku.initSalesNumber = sku?.initSalesNumber | 0
        }
        // 即将开抢时库存不减去initSalesNumber
        if (this.activityStatus === '即将开抢') {
          reserve = sku.groupStock
        } else {
          // 活动开始后库存减去initSalesNumber
          reserve = sku.groupStock - sku.initSalesNumber
        }
        return total + reserve
      }, 0)
    },
    // 解析服务参数数据
    serveParams() {
      try {
        if (!this.goodDetail.commodityServices) {
          return []
        }
        if (typeof this.goodDetail.commodityServices === 'string') {
          return JSON.parse(this.goodDetail.commodityServices)
        }
        return this.goodDetail.commodityServices
      } catch (error) {
        console.error('解析商品参数失败:', error)
        return []
      }
    },
    // 提取所有服务名称用于展示
    paramNamesTextServe() {
      if (this.serveParams.length === 0) {
        return '暂无参数'
      }
      return this.serveParams.map(param => param.serviceName).join(' ')
    },
    // 提取所有参数名称用于展示
    paramNamesText() {
      if (this.parsedProductParams.length === 0) {
        return '暂无参数'
      }
      return this.parsedProductParams.map(param => param.paramName).join(' ')
    },
    // 解析商品参数数据
    parsedProductParams() {
      try {
        if (!this.goodDetail.productParams) {
          return []
        }
        // 如果是字符串,解析为数组
        if (typeof this.goodDetail.productParams === 'string') {
          return JSON.parse(this.goodDetail.productParams)
        }
        // 如果已经是数组,直接返回
        return this.goodDetail.productParams
      } catch (error) {
        console.error('解析商品参数失败:', error)
        return []
      }
    },
    // 当前显示的价格信息
    currentPrice() {
      // 如果有选中的 SKU，使用选中的 SKU 价格
      if (this.selectedSku) {
        return {
          discountPrice: this.selectedSku.discountPrice,
          retailPrice: this.selectedSku.retailPrice,
          skuId: this.selectedSku.skuId,
          skuName: this.selectedSku.skuName,
          img: this.selectedSku.img
        }
      }
      // 否则使用最低价格
      const minSku = this.minRetailPrice(this.goodDetail.activitySkus, 'discountPrice')
      return {
        discountPrice: minSku?.discountPrice || 0,
        retailPrice: minSku?.retailPrice || 0
      }
    }
  },
  created() {
    this.getDetail()
    const defalutAdd = sessionStorage.getItem('defaultAddress')
    if (defalutAdd) {
      this.addressObj = JSON.parse(defalutAdd)
    } else {
      this.queryFirmAddress()
    }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    ...mapMutations('pt', ['setServiceDetail']),
    // 获取当前服务器时间（修正后的时间）
    getServerTime() {
      return Date.now() + this.serverTimeOffset
    },
    // 启动倒计时
    startCountdown() {
      // 清除之前的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }

      // 立即执行一次
      this.updateCountdown()

      // 每秒更新一次
      this.countdownTimer = setInterval(() => {
        this.updateCountdown()
      }, 1000)
    },
    // 更新倒计时
    updateCountdown() {
      const now = this.getServerTime() // 使用服务器时间
      const startTime = new Date(this.goodDetail.activityStartTime).getTime()
      const endTime = new Date(this.goodDetail.activityEndTime).getTime()

      let targetTime
      let isBeforeStart = false

      // 判断活动是否开始
      if (now < startTime) {
        // 活动未开始
        targetTime = startTime
        isBeforeStart = true
        this.countdownText = '后开始'
        this.activityStatus = '即将开抢'
      } else if (now < endTime) {
        // 活动进行中
        targetTime = endTime
        isBeforeStart = false
        this.countdownText = '后结束'
        this.activityStatus = '正在疯抢'
      } else {
        // 活动已结束
        this.hours = '00'
        this.minutes = '00'
        this.seconds = '00'
        this.countdownText = '已结束'
        this.activityStatus = '已结束'
        if (this.countdownTimer) {
          clearInterval(this.countdownTimer)
        }
        // 跳转到首页
        this.$router.go(-1)
        return
      }

      // 计算剩余时间
      const distance = targetTime - now

      if (distance <= 0) {
        // 如果是从未开始到开始,重新计算
        if (isBeforeStart) {
          this.updateCountdown()
        } else {
          this.hours = '00'
          this.minutes = '00'
          this.seconds = '00'
          this.countdownText = '已结束'
          if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
          }
        }
        return
      }

      // 计算时分秒
      const hours = Math.floor(distance / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      // 格式化为两位数
      this.hours = hours.toString().padStart(2, '0')
      this.minutes = minutes.toString().padStart(2, '0')
      this.seconds = seconds.toString().padStart(2, '0')
    },
    // 处理服务下拉菜单展开/收起
    handleServeDropdownChange(visible) {
      this.isServeDropdownVisible = visible
    },
    // 处理参数下拉菜单展开/收起
    handleParamDropdownChange(visible) {
      this.isParamDropdownVisible = visible
    },
    handleRemoveSkuImg() {
      this.currentSkuImg = ''
    },
    goBack() {
      this.$router.go(-1)
    },
    complateAddress() {
      this.queryFirmAddress()
    },
    // 服务详情页面
    toDetail(param) {
      this.setServiceDetail(param)
      this.$router.push({
        name: 'serviceDetail'
      })
    },
    // 联系商家
    handleStorePhone(phone) {
      this.cellStore = phone
      this.$refs.cellphoneRef.showDialog()
      // this.$alert(phone, '联系商家', {
      //   confirmButtonText: '确定'
      // })
    },
    // 跳转店铺详情页
    handleStoreDetail(storeId) {
      this.$router.push({
        name: 'ptOrdinaryStoreDetail',
        query: {
          storeId: storeId
        }
      })
    },
    addList() {
      const params = {
        id: this.addressObj.addressId
      }
      this.$refs.addListDia.openDialog(params)
    },
    goAddress() {
      const params = {
        isAdd: 'add'
      }
      this.$refs.addressDia.openDialog(params)
    },
    changeAddId(address) {
      this.addressObj = address
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      BaseApi.getUserAddress({}).then((response) => {
        // eslint-disable-next-line no-unused-vars
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            for (const item of value) {
              if (item.defaultFlag) {
                this.addressObj = item
                sessionStorage.setItem('defaultAddress', JSON.stringify(item))
              }
            }
          }
        } else {
          this.$message(message)
        }
      })
    },
    getBgColor(val) {
      switch (val) {
        case 'S':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FEECEB 100%)'
        case 'U':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FDF4DA 100%)'
        default:
          return '#fff'
      }
    },
    // 获取商品详情
    getDetail() {
      protocol.param_queryActivityCommodityDetail.param.firmTopId = null
      protocol.param_queryActivityCommodityDetail.param.page = 0
      protocol.param_queryActivityCommodityDetail.param.size = 1
      protocol.param_queryActivityCommodityDetail.param.classId = null
      protocol.param_queryActivityCommodityDetail.param.storeId = null
      protocol.param_queryActivityCommodityDetail.param.commodityId = this.$route.params.commodityId
      protocol.param_queryActivityCommodityDetail.param.activityId = this.$route.params.activityId
      http.postFrontMall(protocol.param_queryActivityCommodityDetail).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.getStoreInfo(value.storeId) // 查询店铺信息
            // 对图片进行排序: isMain为'1'的排在最前面,其他按原顺序
            const sortedImgs = value.imgs.sort((a, b) => {
              if (a.isMain === '1' && b.isMain !== '1') return -1
              if (a.isMain !== '1' && b.isMain === '1') return 1
              return 0
            })
            value.newImgs = sortedImgs
            this.goodDetail = value

            // 启动倒计时
            this.startCountdown()

            // 如果是从确认订单页面返回 恢复数据
            const savedState = this.$store.getters.timeLimitDetailStateGetter
            if (savedState) {
              this.num = savedState.num
              this.selectedSkuIndex = savedState.selectedSkuIndex
              this.selectedSku = savedState.selectedSku
              // 清除状态
              this.$store.commit('setTimeLimitDetailState', null)
              // 调用恢复的 SKU 的限购数量
              if (this.selectedSku) {
                this.getLimitBuy(this.selectedSku)
              }
            } else {
              // 默认选中第一个显示的 SKU
              if (this.goodDetail.activitySkus && this.goodDetail.activitySkus.length > 0) {
                // 找到第一个 display 为 '1' 的 SKU
                const firstVisibleIndex = this.goodDetail.activitySkus.findIndex(sku => sku.display === '1')
                if (firstVisibleIndex !== -1) {
                  this.selectedSkuIndex = firstVisibleIndex
                  this.selectedSku = this.goodDetail.activitySkus[firstVisibleIndex]
                  // 调用默认选中的 SKU 的限购数量
                  this.getLimitBuy(this.selectedSku)
                }
              }
            }
            this.currentSkuImg = this.goodDetail.activitySkus[0].img
          }
        } else {
          Toast(message)
        }
      })
    },
    // 查询店铺信息
    getStoreInfo(storeId) {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryStore))
      apiObj.param = {
        page: 0,
        size: 99999,
        storeId: storeId
      }
      http.postFrontMall(apiObj).then((res) => {
        const { code, value, message } = res.data
        if (Number(code) === 0) {
          this.storeInfo = value.content[0]
        } else {
          Toast(message)
        }
      })
    },
    handleImmediately() {
      this.$message('活动即将开始，请稍作等待~')
    },
    // 立即购买
    handleBuy() {
      const orderData = {
        num: this.num,
        currentPrice: this.currentPrice,
        goodDetail: this.goodDetail,
        selectedSkuIndex: this.selectedSkuIndex,
        addressObj: this.addressObj
      }
      this.$store.commit('setTimeLimitDetailState', {
        num: this.num,
        selectedSkuIndex: this.selectedSkuIndex,
        selectedSku: this.selectedSku
      })
      this.$store.commit('setGoodDetailOrderData', orderData)
      this.$router.push({
        name: 'sureOrderM'
      })
    },
    // 筛选skus对象数组中对象的property属性是最小值的对象
    minRetailPrice(skus, property) {
      let min = ''
      let minIndex = ''
      for (let i = 0; i < skus.length; i++) {
        const el = skus[i]
        if (el.display === '1' && (min === '' || el[property] < min)) {
          min = el[property]
          minIndex = i
        }
      }
      if (minIndex === '') {
        return {
          minIndex: '' // 标记当前获取到的index
        }
      } else {
        const obj = {
          minIndex,
          ...skus[minIndex]
        }
        return obj // 标记当前获取到的index
      }
    },
    // 选择 SKU
    selectSku(sku, index) {
      this.currentSkuImg = sku.img
      this.selectedSkuIndex = index
      this.selectedSku = sku
      this.getLimitBuy(sku)
    },
    getLimitBuy(val) {
      protocol.param_pt_queryLimitNum.param.skuId = val.skuId
      protocol.param_pt_queryLimitNum.param.activityId = val.activityId
      http.postFrontMall(protocol.param_pt_queryLimitNum).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.limitNum = Number(value)
          }
          return true
        } else {
          Toast(message)
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#timeLimitDetail {
  background: #FFFFFF;
  min-height: calc(100vh - 40px);
  // padding-bottom: 50px;
  color: #333;
  position: relative;
  .goBack {
    position: absolute;
    top: 30px;
    left: 50px;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0 0;
    .headerTitle {
      width: 100%;
      height: 104px;
      // background: linear-gradient(0deg, #fff, #FEECEB 100%);
      display: flex;
      gap: 10px;
      padding: 18px 20px;
      box-sizing: border-box;
      // 左侧店铺信息
      .shop-info {
        display: flex;
        align-items: center;
        gap: 12px;
        .shop-logo {
          width: 68px;
          height: 68px;
          background: #FFFFFF;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .shop-details {
        flex: 1;
        .shop-name {
          display: flex;
          align-items: center;
          gap: 10px;
          .shop-img {
            height: 16px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .name {
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }
        }
        .shop-desc {
          margin-top: 3px;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; /* 这里是超出几行省略 */
          overflow: hidden;
          .dot {
            margin: 0 4px;
          }
        }
        .shop-tags {
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 20px;
          .tag-item {
            display: flex;
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
        }
      }
      // 右侧操作按钮
      .shop-actions {
        width: 200px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 16px;
        .action-btn {
          font-size: 14px;
          color: #999999;
          cursor: pointer;
          transition: color 0.3s;
          display: flex;
          align-items: center;
          img {
            margin: 1px 2px 0 0;
          }
          // &:hover {
          //   color: #FF6B4A;
          // }
        }
      }
    }
    // 商品主体内容
    .product-main {
      display: flex;
      gap: 40px;
      background: #FFFFFF;
      height: calc(100vh - 80px - 124px);
      .main_left {
        height: calc(100vh - 80px - 124px);
        overflow-y: auto;
        overflow-x: hidden;
        width: 560px;
        /* 隐藏滚动条 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        .detailsBox {
          margin-top: 44px;
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            margin-bottom: 10px;
          }
          .details {
            width: 100%;
            /deep/ .note-text {
              a {
                color: #2d8cf0 !important;
              }
              .wscnph {
                width: 100%;
              }
            }
            .price-text {
              margin: 10px 0;
              color: #333333;
              font-weight: 500;
              font-size: 14px;
            }
            p {
              font-family: PingFang TC, PingFang TC;
              font-weight: 400;
              font-size: 16px;
            }
          }
        }
      }
      .main_left::-webkit-scrollbar {
        display: none;
      }
      .main_right {
        flex: 1;
        height: calc(100vh - 80px - 124px);
        overflow-y: auto;
        /* 隐藏滚动条 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        .title {
          width: 100%;
          padding-right: 40px;
          box-sizing: border-box;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          // line-height: 34px;
          // display: flex;
          // align-items: center;
          .type {
            width: 85px;
            height: 26px;
            background: #EA593E;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 26px;
            float: left;
            margin-right: 10px;
          }
          .typeEnd {
            width: 66px;
            height: 26px;
            background: #F4F4F4;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
            line-height: 26px;
            text-align: center;
            float: left;
          }
        }
        .tags {
          margin: 9px 0 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
        .priceBox {
          width: 600px;
          height: 46px;
          background-image: url('../../../assets/images/activity/price.png');
          background-size: 100% 100%;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px 0 10px;
          box-sizing: border-box;
          .price-box {
            .current-price {
              font-family: PingFang TC, PingFang TC;
              font-weight: 500;
              font-size: 20px;
              color: #ffffff;
            }
            .original-price {
              font-family: PingFang TC, PingFang TC;
              font-weight: 400;
              font-size: 14px;
              color: #ffffff;
              text-decoration: line-through;
            }
          }
          .stause {
            width: 74px;
            height: 26px;
            background: rgba(255,255,255,0.4);
            box-shadow: inset 0px -8px 18px 0px rgba(255,255,255,0.8);
            border-radius: 6px 6px 6px 6px;
            opacity: 0.5;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
            line-height: 26px;
          }
          .time {
            display: flex;
            align-items: center;
            font-family: PingFang TC, PingFang TC;
            font-weight: 500;
            font-size: 14px;
            color: #EB6643;
            span {
              margin: 0 3px;
            }
            .block {
              padding: 0 3px;
              height: 20px;
              background: #EB6643;
              border-radius: 2px 2px 2px 2px;
              font-family: PingFang TC, PingFang TC;
              font-weight: 500;
              font-size: 14px;
              color: #FFFFFF;
              text-align: center;
              line-height: 20px;
            }
          }
        }
        .inventory {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          margin: 10px 0 16px;
          span {
            margin-right: 10px;
          }
        }
        // .Info {
        //   display: flex;
        //   align-items: center;
        //   justify-content: space-between;
        //   .price-box {
        //     .current-price {
        //       font-family: PingFang TC, PingFang TC;
        //       font-weight: 500;
        //       font-size: 20px;
        //       color: #333;
        //     }
        //     .original-price {
        //       font-family: PingFang TC, PingFang TC;
        //       font-weight: 400;
        //       font-size: 14px;
        //       color: #999999;
        //       text-decoration: line-through;
        //     }
        //   }
        //   .inventory {
        //     font-family: PingFang TC, PingFang TC;
        //     font-weight: 400;
        //     font-size: 14px;
        //     color: #999999;
        //     span {
        //       margin-right: 10px;
        //     }
        //   }
        // }
        .addressInfo{
          margin-top: 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          /deep/.el-icon-arrow-right{
            cursor: pointer;
          }
          .dropdown-arrow {
            transition: transform 0.3s ease;
            display: inline-block;
          }
          .dropdown-arrow.is-reverse {
            transform: rotate(180deg);
          }
          .btwInfo{
            display: flex;
            align-items: center;
            .param-info {
              display: flex;
              align-items: center;
            }
            span {
              margin-left: 20px;
              .param-names-text {
                display: inline-block;
                max-width: 200px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-left: 2px;
              }
            }
            .addAddress {
              width: 72px;
              height: 22px;
              background: #F4F4F4;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              text-align: center;
              line-height: 22px;
              margin-left: 20px;
              cursor: pointer;
            }
          }
          .btwInfo1{
            display: flex;
            align-items: center;
            .contentLeft {
              margin-left: 20px;
              flex: 1;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
            .addAddress {
              width: 72px;
              height: 22px;
              background: #F4F4F4;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              text-align: center;
              line-height: 22px;
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
        .skus {
          margin-top: 14px;
          .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            margin-bottom: 5px;
          }
          .skuItem-scroll {
            height: 280px;
            overflow-y: auto;
            overflow-x: hidden;
            /* 隐藏滚动条 */
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE and Edge */
            .skuItem {
              display: flex;
              flex-wrap: wrap;
              gap: 14px 12px;
              .item {
                width: 274px;
                height: 50px;
                background: rgba(217,217,217,0);
                border-radius: 9px 9px 9px 9px;
                border: 1px solid #F4F4F4;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                text-align: center;
                line-height: 50px;
                cursor: pointer;
              }
              .active {
                border: 1px solid #EB6643;
                color: #EB6643;
              }
            }
          }
        }
        .skusNum {
          position: fixed;
          bottom: 20px;
          margin-top: 30px;
          .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #999999;
            }
          }
          .btnNum {
            display: flex;
            gap: 31px;
            align-items: center;
            /deep/ .el-input-number {
              width: 120px;
            }
            /deep/ .el-input__inner {
              border: 0;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              height: 32px;
              line-height: 32px;
            }
            /deep/ .el-input-number__decrease {
              border-radius: 50%;
              border: 1px solid #DCDFE6;
              background: #fff;
              width: 32px;
              height: 32px;
              line-height: 32px;
            }
            /deep/ .el-input-number__increase {
              border-radius: 50%;
              border: 1px solid #DCDFE6;
              background: #fff;
              width: 32px;
              height: 32px;
              line-height: 32px;
            }
          }
          .btnBuy {
            width: 416px;
            height: 54px;
            background: linear-gradient( 270deg, #EE8C54 0%, #EA553C 100%);
            border-radius: 27px;
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            line-height: 54px;
            cursor: pointer;
          }
          .btnDisabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
      }
      .main_right::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.el-dropdown-menu {
  padding: 0 !important;
  z-index: 0 !important;
  /* 服务说明样式 */
  .serve {
    padding: 10px 14px 22px 17px;
    min-width: 200px;
    h1 {
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin: 0 0 10px 0;
    }
    .item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 12px;
      .label {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
          gap: 6px;
          .img {
            width: 14px;
            height: 14px;
          }
          .serve_text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }
        .rightImg {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }
      .value {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 1.5;
      }
    }
    .no-params {
      text-align: center;
      padding: 20px 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }
  /* 参数信息样式 */
  .parameter {
    padding: 10px 14px 22px 17px;
    h1 {
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin: 0 0 10px 0;
    }
    .param-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      .item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 8px;
        max-width: 230px;
        .label {
          min-width: 80px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        .value {
          flex: 1;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }
      .no-params {
        text-align: center;
        padding: 20px 0;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
